import { connect } from 'react-redux';

import {
  flightsCountSelector,
  loadingStateSelector,
} from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/selectors';
import { getIsMobile } from 'src/store/view/selectors';

import { getArchivedAt } from 'checkout/store/selectors/package';

import { FlightsList } from './FlightsList';

const mapStateToProps = (state) => ({
  flightsCount: flightsCountSelector(state),
  loadingState: loadingStateSelector(state),
  isMobile: getIsMobile(state),
  archivedAt: getArchivedAt(state),
});

export default connect(mapStateToProps)(FlightsList);
